import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

/* Official GXR mark (transparent PNG). Small variant for header/footer, full-res for the hero. */
export function LogoMark({ className = "h-10", light = false, large = false }) {
  return (
    <img
      src={large ? "/assets/gxr_hero_mark.png" : "/assets/gxr_mark_sm.png"}
      alt="GXR"
      className={`${className} object-contain select-none ${light ? "bg-ivory rounded-xl p-1.5 shadow-[0_8px_24px_-12px_rgba(0,0,0,0.5)]" : ""}`}
      draggable={false}
    />
  );
}

/* "Genetics neXt Researchers" with a gold neXt in English; Arabic renders as-is. */
export function BrandName({ light = false }) {
  const { t, i18n } = useTranslation();
  if (i18n.language?.startsWith("ar")) return <>{t("home.hero_title")}</>;
  return (
    <>
      Genetics <span className={light ? "text-gold-light" : "text-gold"}>neXt</span> Researchers
    </>
  );
}

export default function Logo({ light = false, size = "md", compact = false }) {
  const mark = size === "lg" ? "h-14" : "h-10";
  return (
    <Link to="/" data-testid="nav-logo-link" className="flex items-center gap-3 group flex-shrink-0">
      <LogoMark className={`${mark} w-auto transition-transform duration-500 group-hover:scale-[1.04]`} light={light} />
      <span className={`flex-col leading-none ${compact ? "flex xl:hidden 2xl:flex" : "flex"}`}>
        <span className={`font-display font-bold whitespace-nowrap ${size === "lg" ? "text-2xl" : "text-[15px] sm:text-lg"} tracking-wide ${light ? "text-white" : "text-forest"}`}>
          <BrandName light={light} />
        </span>
        <span className={`mt-1 hidden sm:block text-[9px] uppercase tracking-[0.22em] font-semibold ${light ? "text-white/60" : "text-slate"}`}>
          Genetics neXt Researchers
        </span>
      </span>
    </Link>
  );
}
